import { PwaUpdateContext } from './context';
import { PwaUpdateContextValue } from './types';
import { useContext } from 'react';

export const usePwaUpdateContext = (): PwaUpdateContextValue => {
  const context = useContext(PwaUpdateContext);

  if (!context) {
    throw new Error('usePwaUpdateContext must be used within PwaUpdateProvider');
  }

  return context;
};